import { render, staticRenderFns } from "./Pos_supplier_add.vue?vue&type=template&id=6bb006ab&scoped=true&"
import script from "./Pos_supplier_add.vue?vue&type=script&lang=js&"
export * from "./Pos_supplier_add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb006ab",
  null
  
)

export default component.exports